import React from 'react';

import { NumberFormatBase, NumberFormatBaseProps } from 'react-number-format';

import { TextInput } from 'src/common/primitives/TextInput';

import { defaultCurrencyFormat } from './defaultCurrencyFormat';

export const CurrencyInput = React.forwardRef(
  (
    {
      format = defaultCurrencyFormat,
      customInput = TextInput,
      allowNegative = false,
      ...props
    }: NumberFormatBaseProps & {
      allowNegative?: boolean;
      'data-testid'?: string;
    },
    forwardedRef: React.Ref<HTMLInputElement>
  ) => {
    const numberFormatProps: NumberFormatBaseProps = {
      ...props,
    };

    if (allowNegative) {
      numberFormatProps.isValidInputCharacter = (c) => /[0-9-]/.test(c);
      numberFormatProps.removeFormatting = (value) =>
        value.replace(/[^0-9-]/g, '');
      numberFormatProps.format = (rawInput: number | string) => {
        let input = rawInput;

        // Avoid negative 0 converting to -NaN
        if (`${rawInput}`.trim() === '-') {
          input = `0`;
        }
        // Shift negative marker in the middle of the number to the start
        input = `${input}`.replace(/(\d+)-(\d+)/g, '-$1$2');

        const negativeIntent = `${input}`.split('-');

        // Assume shenanigans and drop the negative
        if (negativeIntent.length > 3) {
          input = `${input}`.replace(/[^0-9]/g, '');
        }
        // Test for double negative and invert
        if (negativeIntent.length === 3) {
          input = `${input}`.replace(/[^0-9]/g, '');
        }
        // Test for negative at end of line and shift
        else if (negativeIntent.length === 2 && negativeIntent[1] === '') {
          input = `${input}`.replace(/[^0-9]/g, '');
          input = `-${input}`;
        }
        return defaultCurrencyFormat(input);
      };
    }

    return (
      <NumberFormatBase
        getInputRef={forwardedRef}
        format={defaultCurrencyFormat}
        customInput={customInput}
        {...numberFormatProps}
      />
    );
  }
);
